import chat_big_icon from './img/chat_big_icon.svg'
import useGeneralStore from '../../store/general'
import { useShallow } from 'zustand/react/shallow'
import "./WidgetChat.scss"

const WidgetChat = ({ setIsModalChat }) => {
    
    const {
        unreadCountCommon
    } = useGeneralStore(
        useShallow((state) => ({
            unreadCountCommon: state.unreadCountCommon
        }))
    );

    return (
        <button className='widget-chat'
            onClick={() =>  setIsModalChat(true)}
        >
            <img className='widget-chat__img' src={chat_big_icon} />
            {unreadCountCommon ? <div className='widget-chat__count'>{unreadCountCommon}</div> : null}
        </button>
    )
}

export { WidgetChat }